import React from 'react';
import { Card, CardContent, Typography, Box, Skeleton } from '@mui/material';

interface KPICardProps {
    title: string;
    value: string | number;
    subValue?: string;
    icon: React.ReactNode;
    color?: string; // Hex or theme color path
    loading?: boolean;
}

const KPICard: React.FC<KPICardProps> = ({ title, value, subValue, icon, color = '#3b82f6', loading = false }) => {
    return (
        <Card sx={{ height: '100%', position: 'relative', overflow: 'hidden' }}>
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '4px',
                    height: '100%',
                    bgcolor: color
                }}
            />
            <CardContent>
                {loading ? (
                    <>
                        <Skeleton variant="text" width="60%" />
                        <Skeleton variant="rectangular" width="40%" height={32} sx={{ mt: 1 }} />
                    </>
                ) : (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <Box>
                            <Typography variant="body2" color="text.secondary" fontWeight="medium" sx={{ textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                {title}
                            </Typography>
                            <Typography variant="h4" fontWeight="bold" sx={{ mt: 1, color: 'text.primary' }}>
                                {value}
                            </Typography>
                            {subValue && (
                                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                                    {subValue}
                                </Typography>
                            )}
                        </Box>
                        <Box
                            sx={{
                                p: 1.5,
                                borderRadius: 2,
                                bgcolor: `${color}20`, // 20% opacity of the color
                                color: color,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            {icon}
                        </Box>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default KPICard;
